/**
 * Pure predicate for the "no monitoring agent" org flag
 * (IOrganisationTypeResp.noMonitoringAgentModule). Extracted so the
 * comparison itself — the part most likely to regress into "hides fields
 * for orgs that were never flagged" — is testable without a component
 * TestBed. See docs/decisions/D-074-*.md, docs/findings/F-207-*.md.
 *
 * Fail-open by construction: only the literal number 1 hides fields.
 * Callers must seed their local flag with `false` (or leave it unset) and
 * only call this from inside a successful getOrgTypeDetails response —
 * never eagerly — so a loading state or a failed request always leaves
 * agent-sourced UI visible, matching how multipleTimezoneEnabled /
 * isBiometricEnabled already behave in attendance-report-details.
 */
export function shouldHideAgentFields(flagValue: unknown): boolean {
  return flagValue === 1;
}
